const currencies = [
	{
		value: 'AED',
		label: 'United Arab Emirates Dirham',
	},
	{
		value: 'ALL',
		label: 'Albanian Lek',
	},
	{
		value: 'AMD',
		label: 'Armenian Dram',
	},
	{
		value: 'ANG',
		label: 'Netherlands Antillean Guilder',
	},
	{
		value: 'ARS',
		label: 'Argentine Peso',
	},
	{
		value: 'AUD',
		label: 'Australian Dollar',
	},
	{
		value: 'AZN',
		label: 'Azerbaijani Manat',
	},
	{
		value: 'BDT',
		label: 'Bangladeshi Taka',
	},
	{
		value: 'BGN',
		label: 'Bulgarian Lev',
	},
	{
		value: 'BHD',
		label: 'Bahraini Dinar',
	},
	{
		value: 'BND',
		label: 'Brunei Dollar',
	},
	{
		value: 'BRL',
		label: 'Brazilian Real',
	},
	{
		value: 'BYN',
		label: 'Belarusian Ruble',
	},
	{
		value: 'CAD',
		label: 'Canadian Dollar',
	},
	{
		value: 'CHF',
		label: 'Swiss Franc',
	},
	{
		value: 'CLP',
		label: 'Chilean Peso',
	},
	{
		value: 'CNY',
		label: 'Chinese Yuan',
	},
	{
		value: 'CZK',
		label: 'Czech Koruna',
	},
	{
		value: 'DKK',
		label: 'Danish Krone',
	},
	{
		value: 'DZD',
		label: 'Algerian Dinar',
	},
	{
		value: 'EGP',
		label: 'Egyptian Pound',
	},
	{
		value: 'EUR',
		label: 'Euro',
	},
	{
		value: 'GBP',
		label: 'Pound Sterling',
	},
	{
		value: 'GEL',
		label: 'Georgian Lari',
	},
	{
		value: 'GHS',
		label: 'Ghanaian Cedi',
	},
	{
		value: 'HKD',
		label: 'Hong Kong Dollar',
	},
	{
		value: 'HRK',
		label: 'Croatian Kuna',
	},
	{
		value: 'HUF',
		label: 'Hungarian Forint',
	},
	{
		value: 'IDR',
		label: 'Indonesian Rupiah',
	},
	{
		value: 'ILS',
		label: 'Israeli Shekel',
	},
	{
		value: 'INR',
		label: 'Indian Rupee',
	},
	{
		value: 'IQD',
		label: 'Iraqi Dinar',
	},
	{
		value: 'IRR',
		label: 'Iranian Rial',
	},
	{
		value: 'ISK',
		label: 'Icelandic Krona',
	},
	{
		value: 'JOD',
		label: 'Jordanian Dinar',
	},
	{
		value: 'JPY',
		label: 'Japanese Yen',
	},
	{
		value: 'KES',
		label: 'Kenyan Shilling',
	},
	{
		value: 'KGS',
		label: 'Kyrgystani Som',
	},
	{
		value: 'KHR',
		label: 'Cambodian Riel',
	},
	{
		value: 'KRW',
		label: 'South Korean Won',
	},
	{
		value: 'KWD',
		label: 'Kuwaiti Dinar',
	},
	{
		value: 'KZT',
		label: 'Kazakhstani Tenge',
	},
	{
		value: 'LAK',
		label: 'Laotian Kip',
	},
	{
		value: 'LBP',
		label: 'Lebanese Pound',
	},
	{
		value: 'LKR',
		label: 'Sri Lankan Rupee',
	},
	{
		value: 'LYD',
		label: 'Libyan Dinar',
	},
	{
		value: 'MAD',
		label: 'Moroccan Dirham',
	},
	{
		value: 'MDL',
		label: 'Moldovan Leu',
	},
	{
		value: 'MKD',
		label: 'Macedonian Denar',
	},
	{
		value: 'MMK',
		label: 'Myanma Kyat',
	},
	{
		value: 'MXN',
		label: 'Mexican Peso',
	},
	{
		value: 'MYR',
		label: 'Malaysian Ringgit',
	},
	{
		value: 'NOK',
		label: 'Norwegian Krone',
	},
	{
		value: 'NPR',
		label: 'Nepalese Rupee',
	},
	{
		value: 'NZD',
		label: 'New Zealand Dollar',
	},
	{
		value: 'OMR',
		label: 'Omani Rial',
	},
	{
		value: 'PHP',
		label: 'Philippine Peso',
	},
	{
		value: 'PKR',
		label: 'Pakistani Rupee',
	},
	{
		value: 'PLN',
		label: 'Polish Zloty',
	},
	{
		value: 'QAR',
		label: 'Qatari Rial',
	},
	{
		value: 'RON',
		label: 'Romanian Leu',
	},
	{
		value: 'RSD',
		label: 'Serbian Dinar',
	},
	{
		value: 'RUB',
		label: 'Russian Ruble',
	},
	{
		value: 'SAR',
		label: 'Saudi Riyal',
	},
	{
		value: 'SEK',
		label: 'Swedish Krona',
	},
	{
		value: 'SGD',
		label: 'Singapore Dollar',
	},
	{
		value: 'THB',
		label: 'Thai Baht',
	},
	{
		value: 'TJS',
		label: 'Tajikistani Somoni',
	},
	{
		value: 'TMT',
		label: 'Turkmenistani Manat',
	},
	{
		value: 'TND',
		label: 'Tunisian Dinar',
	},
	{
		value: 'TRY',
		label: 'Turkish Lira',
	},
	{
		value: 'TWD',
		label: 'New Taiwan Dollar',
	},
	{
		value: 'UAH',
		label: 'Ukrainian Hryvnia',
	},
	{
		value: 'USD',
		label: 'US Dollar',
	},
	{
		value: 'UZS',
		label: 'Uzbekistan Som',
	},
	{
		value: 'VND',
		label: 'Vietnamese Dong',
	},
	{
		value: 'ZAR',
		label: 'South African Rand',
	},
];

export default currencies;
